export default __webpack_public_path__ + "static/media/dashboard_xn.cdcbf517.svg";